<div class="wrapper">
    <app-error-model
        message="{{ eMessage }}"
        [display]="display"
        (event)="closeModel($event)"></app-error-model>
    <app-success-model
        message="{{ sMessage }}"
        [display]="displaySuccess"
        (event)="closeModel($event)"></app-success-model>
    <app-navigation *ngIf="(sessionUser$ | async)?.isAdmin()"></app-navigation>
    <app-enterprise-navigation
        *ngIf="(sessionUser$ | async)?.isEnterprise()"></app-enterprise-navigation>
    <div class="content-wrapper">
        <app-content-transition></app-content-transition>
        <app-header location="User Account Profile"></app-header>
        <app-enterprise-links [id]="id"></app-enterprise-links>
        <section class="add-section" *ngIf="enterprise.code">
            <a class="text-danger" (click)="resendLink()"
                ><u>Resend Create Password Email Link</u></a
            >
        </section>
        <section class="add-section">
            <div class="row">
                <div class="col-md-8 section-heading">Enterprise Settings</div>
                <div class="col-md-4 add-section-heading">
                    <app-edit-pencil (edit)="changeView($event, 'enterprise')"></app-edit-pencil>
                </div>
            </div>
            <div *ngIf="!editEnterprise">
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-label">ACCOUNT STATUS</label>
                        <div class="user-details-text">
                            {{ enterprise.status || '-' | humanize }}
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">KYC LEVEL</label>
                        <div class="user-details-text">
                            {{ enterprise.kycLevel || '-' | humanize }}
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">ADD ACCOUNT TO PAY LIST</label>
                        <div class="user-details-text">
                            {{ enterprise ? (enterprise.visibleInPayList ? 'YES' : 'NO') : '-' }}
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">DIRECT DISTRIBUTOR</label>
                        <div class="user-details-text">
                            {{
                                enterprise.supplierEnabled
                                    ? enterprise?.supplier?.directDistributor
                                        ? 'YES'
                                        : 'NO'
                                    : '-'
                            }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-label">SUPPLEIR</label>
                        <div class="user-details-text">
                            {{ enterprise ? (enterprise.supplierEnabled ? 'YES' : 'NO') : '-' }}
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">WHOLESALER</label>
                        <div class="user-details-text">
                            {{ enterprise ? (enterprise.wholesalerEnabled ? 'YES' : 'NO') : '-' }}
                        </div>
                    </div>
                    <div class="col-md-3" *ngIf="isWholesaler">
                        <label class="form-label">INTEGRATED WITH LOVCASH</label>
                        <div class="user-details-text">
                            {{
                                enterprise
                                    ? enterprise?.wholesaler?.lovcashIntegrated
                                        ? 'YES'
                                        : 'NO'
                                    : '-'
                            }}
                        </div>
                    </div>
                    <div class="col-md-3" *ngIf="isLovcashIntegrated">
                        <label class="form-label pr-3">API AUTH KEY</label>

                        <div class="input-icon-wrapper">
                            <input
                                class="form-input"
                                type="text"
                                [value]="apiKeyDisplayValue"
                                readonly />

                            <!-- Regenerate -->
                            <i
                                class="fa fa-refresh action-icon"
                                [class.text-danger]="apiKeyExists"
                                [attr.title]="apiKeyExists ? 'Rotate API Key' : 'Generate API Key'"
                                (click)="onApiKeyActionClick()">
                            </i>

                            <!-- Copy only if we have raw key in memory -->
                            <i
                                class="fa action-icon copy-icon"
                                [ngClass]="canCopyRawKey ? 'fa-clipboard' : 'fa-lock'"
                                [class.disabled]="!canCopyRawKey"
                                [style.cursor]="canCopyRawKey ? 'pointer' : 'not-allowed'"
                                [attr.title]="
                                    canCopyRawKey ? 'Copy API Key' : 'Key hidden for security'
                                "
                                (click)="copyApiKey($event)">
                            </i>
                        </div>

                        <small *ngIf="enterprise?.wholesaler?.apiKeyRotatedAt">
                            Last rotated:
                            {{ enterprise.wholesaler.apiKeyRotatedAt | date: 'medium' }}
                        </small>
                    </div>
                </div>
                <section class="mt-4" *ngIf="enterpriseFeeList.length > 0">
                    <app-enterprise-fees
                        title="Fees Paid by Enterprise User"
                        [showEditPencil]="false"
                        [parentToUpdate]="true"
                        [editEnterprise]="editEnterprise"
                        [enterpriseFeeList]="enterpriseFeeList"
                        (updateFee)="submit()">
                    </app-enterprise-fees>
                </section>
            </div>
            <div *ngIf="editEnterprise">
                <form [formGroup]="form" (ngSubmit)="submit(); $event.preventDefault()">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-label">ACCOUNT STATUS</label>
                            <app-select-box
                                placeholderValue="Set Status"
                                value="enterpriseStatus"
                                [form]="form"
                                [invalidForm]="invalidForm"
                                [dropDown]="statusDropdown">
                            </app-select-box>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">KYC LEVEL</label>
                            <app-select-box
                                placeholderValue="Set Kyc Level"
                                value="kycLevel"
                                [form]="form"
                                [invalidForm]="invalidForm"
                                [dropDown]="kycLevelDropdown">
                            </app-select-box>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label pr-3">ADD ACCOUNT TO PAY LIST</label>
                            <br />
                            <label class="switch-container">
                                <input
                                    type="checkbox"
                                    (change)="changeStatus()"
                                    [checked]="isVisible" />
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label pr-3">DIRECT DISTRIBUTOR</label>
                            <br />
                            <label class="switch-container">
                                <input
                                    type="checkbox"
                                    (change)="changeDirectDistributor()"
                                    [checked]="isDirectDistributor" />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-label pr-3">SUPPLIER</label>
                            <br />
                            <label class="switch-container" [ngClass]="{ shake: supplierShake }">
                                <input
                                    type="checkbox"
                                    (change)="changeIsSupplier($event)"
                                    [checked]="isSupplier" />
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label pr-3">WHOELSALER</label>
                            <br />
                            <label class="switch-container" [ngClass]="{ shake: wholesalerShake }">
                                <input
                                    type="checkbox"
                                    (change)="changeIsWholesaler($event)"
                                    [checked]="isWholesaler" />
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <div class="col-md-3" *ngIf="isWholesaler">
                            <label class="form-label pr-3">INTEGRATED WITH LOVCASH</label>
                            <br />
                            <label class="switch-container">
                                <input
                                    type="checkbox"
                                    (change)="changeLovcashIntegrated()"
                                    [checked]="isLovcashIntegrated" />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <section class="mt-4" *ngIf="enterpriseFeeList.length > 0">
                        <app-enterprise-fees
                            title="Fees Paid by Enterprise User"
                            [showEditPencil]="false"
                            [parentToUpdate]="true"
                            [editEnterprise]="editEnterprise"
                            [enterpriseFeeList]="enterpriseFeeList"
                            (updateFee)="submit()">
                        </app-enterprise-fees>
                    </section>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button class="custombtn custombtn-align-right">SAVE</button>
                            <button
                                type="button"
                                class="user-files-deny btn btn-link"
                                (click)="changeView($event, 'enterprise')">
                                <u>CANCEL</u>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    </div>

    <app-modal
        modalId="{{ apiKeyWarningModalId }}"
        modalTitle="Regenerate API AUTH KEY"
        buttonConfirmText="Continue"
        buttonCancelText="Cancel"
        (modalEventConfirm)="openApiKeyPinModal()"
        (modalEventCancel)="closeApiKeyWarningModal()">
        <div class="section-heading alert bg-danger-soft mb-3">
            <strong>Stop!</strong> This action cannot be undone.
        </div>
        <div>
            You are about to refresh the API AUTH KEY which will terminate the integration with the
            wholesaler's RMS provider. This will disrupt the services between Lovcash and the RMS
            provider.
        </div>
    </app-modal>

    <app-modal
        modalId="{{ apiKeyPinModalId }}"
        modalTitle="CONFIRM THE API AUTH KEY REFRESH"
        buttonConfirmText="Continue"
        buttonCancelText="Cancel"
        [closeOnConfirm]="false"
        [confirmLoading]="pinConfirmLoading"
        [disableConfirm]="!isPinValid"
        (modalEventConfirm)="authenticate()"
        (modalEventCancel)="closeApiKeyPinModal()">
        <div class="section-heading alert bg-danger-soft mb-3">
            <strong>Stop!</strong> This action cannot be undone.
        </div>

        <div>Please use your PIN to confirm the API AUTH KEY refresh action.</div>
        <div class="row mt-3">
            <div class="col-md-8">
                <div>
                    <input
                        #pinInput
                        class="form-input"
                        type="password"
                        [(ngModel)]="pin"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Admin Password"
                        (keydown.enter)="isPinValid && authenticate()" />
                    <small class="text-muted d-block">Enter your admin PIN</small>

                    <div class="invalid-feedback d-block" *ngIf="pinError">
                        {{ pinError }}
                    </div>
                </div>
            </div>
        </div>
    </app-modal>
</div>
